import "./web3gl"

function App() {
  return <div></div>;
}

export default App;